/** Formatage partagé par les écrans. */
export const esc = (s: string) =>
  s.replace(/[<>&"]/g, (c) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" })[c]!)

export const nb = (n: number) => Math.round(n).toLocaleString("fr-FR")

export const duree = (s: number) =>
  s < 60 ? `${Math.round(s)} s` : s < 3600 ? `${Math.round(s / 60)} min` : `${(s / 3600).toFixed(1)} h`

/** Une jauge, creusée et surlignée comme celles du jeu. */
export const jauge = (ratio: number, teinte: string, id = "") =>
  `<div class="jauge"><i ${id ? `id="${id}"` : ""} style="width:${Math.max(0, Math.min(100, ratio * 100))}%;background:${teinte}"></i></div>`

export const vert = "linear-gradient(#9ac45f,#5f8038)"
export const orJauge = "linear-gradient(#e8c169,#b8862c)"
export const rougeJauge = "linear-gradient(#d3694a,#9a3d26)"

/**
 * Panneau de détail **ancré au bas de l'écran**, au-dessus de la barre.
 *
 * Un détail placé à la suite d'une grille devient inatteignable dès que la
 * grille est longue : sélectionner la troisième pièce d'un coffre de cent
 * obligeait à dévaler la page pour lire son jet, puis à remonter pour en
 * choisir une autre. Ancré, il est visible sans un seul défilement et ne se
 * déplace pas quand on passe d'un objet au suivant.
 */
export const feuille = (corps: string) =>
  `<div class="feuille"><button class="fermerfeuille" data-fermer="1" aria-label="Fermer">×</button>${corps}</div>`
